import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_EMAILS_BEGIN](state) {
    state.emailTemplatesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_EMAILS_SUCCESS](state, emailTemplate) {
    state.emailTemplatesGetError = null;
    state.emailTemplates = emailTemplate;
    state.emailTemplatesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_EMAILS_ERROR](state, err) {
    state.emailTemplatesGetState = API_STATES.REQUEST_ERROR;
    state.emailTemplatesGetError = err;
  }
};

export default mutations;
